import React from "react";
import { Typography, Paper, Avatar, Tooltip, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";

const useStyles = makeStyles((theme) => ({
  rightTitle: {
    fontWeight: 900,
    marginBottom: theme.spacing(0.5),
  },
  rightHint: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
    lineHeight: 1.6,
  },
  rightTitleNoHint: {
    marginBottom: theme.spacing(1.5),
  },
  actionsWrap: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: theme.spacing(1.5),
  },
  actionsWrapCompact: {
    gap: theme.spacing(1),
  },
  actionCard: {
    borderRadius: 14,
    border: "1px solid rgba(0,0,0,0.08)",
    background: "#fff",
    padding: theme.spacing(1.4),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    cursor: "pointer",
    transition:
      "transform .12s ease, box-shadow .12s ease, border-color .12s ease",
    boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 8px 22px rgba(0,0,0,0.08)",
      borderColor: "rgba(0,0,0,0.14)",
    },
  },
  actionCardCompact: {
    padding: theme.spacing(1.1),
  },
  iconAvatar: {
    width: 44,
    height: 44,
    borderRadius: 12,
    background: "rgba(0,0,0,0.04)",
    color: theme.palette.text.primary,
    fontWeight: 900,
  },
  iconAvatarCompact: {
    width: 40,
    height: 40,
  },
  actionText: {
    flex: 1,
    minWidth: 0,
  },
  actionTitle: {
    fontWeight: 900,
    lineHeight: 1.15,
  },
  actionSubtitle: {
    marginTop: 3,
    fontSize: 13,
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  statusIcon: {
    fontSize: 22,
  },
  statusOk: {
    color: theme.palette.primary.main,
    "&:hover": {
      color: theme.palette.primary.dark,
    },
  },
  statusNo: {
    color: "rgba(0,0,0,0.35)",
  },
}));

function ActionItem({ title, subtitle, icon, done = false, onClick, tooltip, compact, disabled = false }) {
  const classes = useStyles();
  return (
    <Paper
      className={`${classes.actionCard} ${compact ? classes.actionCardCompact : ""}`}
      elevation={0}
      onClick={disabled ? undefined : onClick}
      style={{ cursor: disabled ? "default" : "pointer", opacity: disabled ? 0.6 : 1 }}>
      <Avatar
        className={`${classes.iconAvatar} ${compact ? classes.iconAvatarCompact : ""}`}
        variant="rounded"
      >
        {icon}
      </Avatar>
      <div className={classes.actionText}>
        <Typography className={classes.actionTitle}>{title}</Typography>
        <Typography className={classes.actionSubtitle}>{subtitle}</Typography>
      </div>
      <Tooltip title={tooltip || title}>
        <IconButton size="small" onClick={(e) => e.stopPropagation()}>
          {done ? (
            <CheckBoxIcon
              className={`${classes.statusIcon} ${classes.statusOk}`}
            />
          ) : (
            <CheckBoxOutlineBlankIcon
              className={`${classes.statusIcon} ${classes.statusNo}`}
            />
          )}
        </IconButton>
      </Tooltip>
    </Paper>
  );
}

export default function SectionListMentora({ title = "Secciones del planeador", hint = "Selecciona una sección para gestionarla.", hideHint = false, items = [], compact = false }) {
  const classes = useStyles();
  const showHint = Boolean(hint) && !hideHint;
  return (
    <div>
      <Typography className={`${classes.rightTitle} ${!showHint ? classes.rightTitleNoHint : ""}`}>
        {title}
      </Typography>
      {showHint && <Typography className={classes.rightHint}>{hint}</Typography>}
      <div className={`${classes.actionsWrap} ${compact ? classes.actionsWrapCompact : ""}`}>
        {items.map((it) => (
          <ActionItem
            key={it.key}
            title={it.title}
            subtitle={it.subtitle}
            icon={it.icon}
            done={it.done}
            onClick={it.disabled ? undefined : it.onClick}
            tooltip={it.tooltip}
            compact={compact}
            disabled={it.disabled}
          />
        ))}
      </div>
    </div>
  );
}